const NotificationLink = () => import('~pages/CustomerPortal/NotificationLink.vue')

export default [
  {
    name: 'notificationLink',
    path: '/notificationLink',
    component: NotificationLink,
    meta: {
      bypassToken: true
    }
  }
]
